import { combineReducers } from "redux";
import { HYDRATE } from "next-redux-wrapper";
import address from "./address-reducer";
import advertising from "./advertising-reducer";
import navigation from "./navigation-reducer";
import buyClosetItemsReducer from "./buy-closet-items-reducer";
import customizableCloset from "./customizable-closet-reducer";
import drawer from "./drawer-reducer";
import features from "./features-reducer";
import flashes from "./flashes-reducer";
import user from "./user-reducer";
import tunnelSteps from "./tunnel-steps-reducer";
import giftCardInfos from "./gift-card-reducer";
import navSearchReducer from "./nav-search-reducer";
import referralRewardsReducer from "./referral-rewards-reducer";
import cartReducer from "./cart-reducer";
import userlists from "./userlists-reducer";
import catalogReducer from "./catalog-reducer";

export const INITIAL_STATE = {};

const combinedReducer = combineReducers({
  address: address || {},
  advertising: advertising || {},
  buyClosetItems: buyClosetItemsReducer || {},
  cart: cartReducer || {},
  catalog: catalogReducer || {},
  customizableCloset: customizableCloset || {},
  drawer: drawer || {},
  features: features || {},
  flashes: flashes || {},
  giftCardInfos: giftCardInfos || {},
  navigation: navigation || {},
  navSearch: navSearchReducer || {},
  referralRewards: referralRewardsReducer || {},
  tunnelSteps: tunnelSteps || {},
  user: user || {},
  userlists: userlists || {},
});

const rootReducer = (state, action) => {
  if (action.type === HYDRATE) {
    const nextState = {
      ...state,
      features: action.payload.features,
      advertising: action.payload.advertising,
      navSearch: action.payload.navSearch,
    };

    return nextState;
  } else {
    return combinedReducer(state, action); // Delegate other actions to the combined reducers
  }
};

export default rootReducer;
